import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import StrategyCard from '../strategy-card/index.vue';
import StratStats from '../strat-stats/index.vue';
import { Strategy } from '@/classes/Strategy';
import { StrategyResults } from '@/classes/StrategyResults';

@Component({
  name: 'strategy-view',
  components: {
    StrategyCard,
    StratStats,
  },
})
export default class StrategyView extends Vue {
  @Prop()
  public strategy!: Strategy;


  @Prop()
  public type!: string;



  public slippageIndex = 0;

  public selected: StrategyResults = this.strategy.getTypeResults(this.type)[0];

  @Watch('strategy')
  strategyChange(oldVal: Strategy, newVal: Strategy) {
    this.selected = newVal.getTypeResults(this.type)[0];
  }

  @Watch('type')
  typeChange(oldVal: string, newVal: string) {
    this.selected = this.strategy.getTypeResults(newVal)[0];
  }

  get slippageResults() {
    return this.strategy.getTypeResults(this.type)
  }


  onClose() {
    this.$emit('strategyClose')
  }
}
